/*
 * @since: 2020-06-12
 * @author: tams_dev1
*/
import resultFactory from '~/utils/resultFactory'

const makeParamCenterBranch = (axiosData, state, type) => {
  axiosData.vpn_branch_policy_id = (type === 'ADD') ? state.defaultId : state.rowSelectItems[0].vpn_branch_policy_id
  axiosData.device_id = (type === 'ADD') ? state.selectedDevice.deviceId : state.rowSelectItems[0].device_id
  if (axiosData.vpn_branch_policy_auth_type === 1) {
    axiosData.vpn_branch_policy_passwd = ''
  } else {
    if (axiosData.vpn_branch_policy_passwd !== undefined && axiosData.vpn_branch_policy_passwd !== '') {
      axiosData.vpn_branch_policy_passwd = btoa(axiosData.vpn_branch_policy_passwd)
    }
  }
  if (axiosData.vpn_branch_policy_extnd_mode_use === 0) {
    axiosData.center = []
    axiosData.branch = []
  } else if (axiosData.vpn_branch_policy_extnd_mode_use === 1) {
    axiosData.center_branch = []
  }
  return axiosData
}

const makeExtndOffModeData = (data) => {
  if (data.vpn_branch_policy_extnd_mode_use === 0) {
    for (const item of data.center_branch) {
      // add center
      data.center.push(
        item.center
      )
      // add branch
      data.branch.push(
        item.branch
      )
    }
  }
  return data
}

export const state = () => ({
  url: '/api/vp/ipsec/4/branch/policies',
  deviceUrl: '/api/vp/ipsec/4/branch/policies/device',
  confirmUrl: '/api/vp/command/ipsec-ipv4-branch-policies',
  centerObjectUrl: '/api/cm/vpn-branch/center/addr-obj',
  branchObjectUrl: '/api/cm/vpn-branch/addr-obj',
  usedSettingUrl: '/api/vp/ipsec/4/bulk/branch/policies',
  deleteUrl: '/api/vp/ipsec/4/branch/policies/multi',

  selectedDevice: {},
  defaultId: '',
  rowSelectItems: [],
  dataList: [],
  axiosModel: {},
  policyModel: {},
  interfacesModel: {},
  bridegeModel: {},
  trunkModel: {},
  interfacesSet: {
    item: '',
    v4_Options: [],
    v6_Options: []
  }
})

export const mutations = {
  clearStore: (state) => {
    state.selectedDevice = {}
    state.rowSelectItems = []
    state.dataList = []
    state.interfacesModel = {}
    state.interfacesSet = {}
  },
  deviceInfo: (state, item) => {
    state.selectedDevice = item
  },
  setRowSelectItems (state, data) {
    state.rowSelectItems = data
  },
  getTableList (state, data) { // 지점 등록 목록 조회
    for (const d of data) {
      makeExtndOffModeData(d)
    }
    state.dataList = _.cloneDeep(data)
  },
  getDefaultId (state, payload) {
    state.defaultId = _.cloneDeep(payload[0].vpn_branch_policy_id)
  },
  addTableList (state, data) { // 지점 등록 추가
    state.dataList.push(makeExtndOffModeData(data))
  },
  edtTableList: (state, data) => {
    state.dataList = _.map(state.dataList, (item) => {
      if (item.vpn_branch_policy_id === data.vpn_branch_policy_id) {
        item = _.cloneDeep(makeExtndOffModeData(data))
        item.device_uname = _.cloneDeep(data.device_uname)
      }
      return item
    })
  },
  tableHeaderMutation: (state, data) => {
    state.dataList = _.map(state.dataList, (item) => {
      const temp = _.findIndex(data.items, ['vpn_branch_policy_id', item.vpn_branch_policy_id])
      if (temp > -1) {
        item.vpn_branch_policy_use = data.vpn_branch_policy_use
      }
      return item
    })
  }
}

export const actions = {
  // 지점 등록 빈 설정 (추가시 빈 id 조회)
  async getDefaultId ({commit, state}) {
    try {
      const data = await this.$axios.$post(`${state.deviceUrl}/${state.selectedDevice.deviceId}`, null, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getDefaultId', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 지점 등록 목록 조회
  async getTableList ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.url)
      return resultFactory(commit, {length: null, data: data, action: 'getTableList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 지점 등록 추가
  async addTableList ({commit, dispatch, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.url}/${state.defaultId}`, makeParamCenterBranch(payload, state, 'ADD'), {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'addTableList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 지점 등록 편집
  async edtTableList ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(`${state.url}/${state.rowSelectItems[0].vpn_branch_policy_id}`, makeParamCenterBranch(payload, state, 'EDIT'))
      return resultFactory(commit, {length: null, data: data, action: 'edtTableList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 지점 등록 일괄수정
  async usedSetting ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(state.usedSettingUrl, payload, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  //  지점 등록 삭제
  async delTableList ({commit, state}) {
    const idList = []
    if (state.rowSelectItems.length > 0) {
      state.rowSelectItems.forEach((item) => {
        idList.push({'vpn_branch_policy_id': item.vpn_branch_policy_id})
      })
    }
    try {
      const data = await this.$axios.$delete(state.deleteUrl, {data: {items: idList}}, {failAlert: false})
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.url}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return false
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
export const getters = {
}
export const strict = false
